<template>
  <div class="flex items-center gap-[0.5em] text-left">
    <AtomIcon name="location-dot" class="text-coral w-[0.875em]" :class="{ 'text-[1.375em]': !address, 'text-[1.25em]': !name, 'text-[1.625em]': name && address }" />
    <div>
      <p v-if="name" class="font-medium text-[1em] line-clamp-1" v-html="name" />
      <p v-if="address" class="opacity-60 text-[0.875em] line-clamp-1" v-html="address" />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    default: ''
  },
  address: {
    type: String,
    default: ''
  }
})
</script>